import React from 'react'
import MaterialTable from "material-table";
import { connect } from "react-redux";
import "../../styles/Empresa.css";
import MensajeFlash from '../mensajeFlash/MensajeFlash';
import Navbar from '../home/Navbar';
import { Link, useLocation } from "react-router-dom";
import { getTramites } from "./TramitesService";
import { codigoTramiteCerrado, codigoTramiteFirmado } from '../../constans/constants';
import pdfIcon from '../../styles/icons/pdf.svg'

export class TramitesCerrados extends React.Component {

    constructor(props){
        super(props)
        this.state = {
            mostrarMensajeFlash: false,
            mensajeFlash: "",
            severityFlash: "",
        }
        localStorage.setItem("urlAnterior", window.location.href);
        this.tableRef = React.createRef();

    }


    handleCloseMensajeFlash = () => {
        this.setState({
          mostrarMensajeFlash: false,
        });
      };
    

    render() {
        return (

            <div>
                <div className="dashboardContent">
                    <div className="container-fluid">
                        <div className="sectionHeader">
                            <h1 className="pageTitle"> Tramites Cerrados</h1>
                        </div>

                        <Navbar
                            menuActual={window.location.hash}
                            seccionActual={'tramites'}
                        />

                        <MensajeFlash
                            mensaje={this.state.mensajeFlash}
                            severity={this.state.severityFlash}
                            open={this.state.mostrarMensajeFlash}
                            handleClose={this.handleCloseMensajeFlash} />
                        <div className="contentPage card" style={{ padding: '0px' }}>
                        <MaterialTable
                title="Recibos"
                style={{ borderRadius: ".5rem" }}
                tableRef={this.tableRef}
                columns={[
                  { title: "Tramite", field: "nombre" },
                  { title: "Fecha de Creación", field: "fechaCarga" },
                  { title: "Estado", field: "estado" },
                ]}
                data={(query) =>
                  new Promise((resolve, reject) => {
                    this.props
                      .getTramites(query.page, query.pageSize, query.search,codigoTramiteCerrado)
                      .then(() => {
                        resolve({
                          data: this.props.tramitesData.tramites,
                          page: this.props.tramitesData.page,
                          totalCount: this.props.tramitesData.totalCount,
                        });
                      });
                  })
                }
                actions={[rowData => ({
                    icon: () =>
                      <Link to={{
                        pathname: '/tramites/'+rowData.nombre+"/"+rowData.fechaCarga+"/"+rowData.id,
                        
                        state: {
                          nombreTramite: rowData.nombre,
                          fechaCarga: rowData.fechaCarga,
                          redirect: this.props.location.pathname,
                        }
                      
                      }}>
                        <img src={pdfIcon} />
                      </Link>,
                    tooltip: 'Ver',
                    onClick: (rowData) => {
                    }
                  })]}
                options={{
                  actionsColumnIndex: -1,
                  sorting: false,
                  paginationType: "stepped",
                  search: true,
                  showTextRowsSelected: false,
                  showTitle: false,
                  toolbar: true,
                  detailPanelColumnAlignment: "right",
                  headerStyle: {
                    background: "#edf2f9",
                    fontFamily: "Open Sans",
                    fontWeight: "bold",
                  },
                }}
                localization={{
                  body: {
                    emptyDataSourceMessage: "No hay resultados que mostrar",
                  },
                  header: {
                    actions: "Acciones",
                  },
                  pagination: {
                    labelDisplayedRows: "{from}-{to} de {count}",
                    nextTooltip: "Página Siguiente",
                    previousTooltip: "Página Anterior",
                    firstTooltip: "Primera Página",
                    lastTooltip: "Última Página",
                    labelRowsSelect: "Filas",
                  },
                  toolbar: {
                    searchPlaceholder: "Buscar",
                    searchTooltip: "Buscar",
                  },
                }}
              />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    getTramites: (page, size, search,estado) =>
      dispatch(getTramites(page, size, search,estado)),
  });
  
  const mapStateToProps = (state) => ({
    tramitesData: state.tramitesData,
  });
  
export default connect(mapStateToProps, mapDispatchToProps)(TramitesCerrados);